import { ReactElement } from 'react'

import { Select } from 'antd'
import { Field } from 'formik'
import { useTranslation } from 'react-i18next'

import { FormikSelect } from 'components/formik'
import { SelectOptionContent } from 'components/SelectOptionContent'
import { AdGroup } from 'types'

import { useAdGroupOptions } from './localHooks'
import { AdGroupSelectFieldProps } from './localTypes'

const AdGroupForSearchTermKeywordSelectField = ({
    name,
    campaignId,
    disabled = false,
    style = { width: '100%' },
    isOptionDisabled,
    optionMetadata,
}: AdGroupSelectFieldProps): ReactElement => {
    const { t } = useTranslation('automations')

    const resolvedIsOptionDisabled =
        isOptionDisabled ?? ((option: AdGroup) => !option.has_positive_keywords)

    const resolvedOptionMetadata =
        optionMetadata ??
        ((option: AdGroup) =>
            option.has_positive_keywords
                ? ''
                : t(
                      'automations:productTargetingNotSupported',
                      'Ad groups targeting products are not supported'
                  ))

    const [loading, options] = useAdGroupOptions({
        name,
        campaignId,
        isOptionDisabled: resolvedIsOptionDisabled,
        optionMetadata: resolvedOptionMetadata,
    })

    return (
        <Field
            name={name}
            component={FormikSelect}
            placeholder={t(
                'automations:adGroupSelect.selectTargetAdGroup',
                'Select Target Ad Group'
            )}
            style={style}
            loading={loading}
            disabled={disabled || loading}
        >
            {options.map((option, idx) => (
                <Select.Option
                    key={idx}
                    value={option.value}
                    title={option.label}
                    disabled={option.disabled}
                >
                    <SelectOptionContent
                        label={option.label}
                        metadata={option.metadata}
                    />
                </Select.Option>
            ))}
        </Field>
    )
}

export default AdGroupForSearchTermKeywordSelectField
